import {useUpdateCartMutation} from 'modules/cart/services';
import {useCallback, useMemo} from 'react';
import _debounce from 'lodash/debounce';
import {DEBOUNCE_DELAY_SECOND} from 'core/constants';

interface IProps {
    id?: number;
}

export const useUpdateProductInCart = ({id}: IProps) => {
    const [apiUpdateCart] = useUpdateCartMutation();

    const updateCart = useCallback(
        async (quantity: number, cb?: () => void) => {
            if (!id) {
                return;
            }

            try {
                await apiUpdateCart({
                    id,
                    quantity,
                }).then((result) => {
                    if ('error' in result) {
                        return;
                    }

                    cb?.();
                });
            } catch (e) {
                console.error(e);
            }
        },
        [apiUpdateCart, id],
    );

    const updateCartDebounced = useMemo(() => {
        return _debounce(async (value, cb?: () => void) => {
            await updateCart(value, cb);
        }, DEBOUNCE_DELAY_SECOND);
    }, [updateCart]);

    return useMemo(() => {
        return {
            updateCart,
            updateCartDebounced,
        };
    }, [updateCart, updateCartDebounced]);
};
